/**
 * API Utilities
 *
 * Shared utilities for API calls (used by app-specific hooks)
 */

export { API_URLS, DEFAULT_QUERY_OPTIONS, fetchJson, fetchJsonWithNotFound } from "./shared";

// API hooks
export { useWebsiteConfig } from "./useWebsiteConfig";
export { useStakingStats } from "./useStakingStats";
